import React from 'react';
import Paper from '@material-ui/core/Paper';
import '../styles/chart-styles.css';

export default (props) => {
    return (
        <Paper>
            <div className="tooltip-container">
                {props.children}
            </div>      
        </Paper>
    );

}



// WEBPACK FOOTER //
// ./src/components/CustomTooltip.js